
import React from 'react';
import { EditFacilityOrderTemplateInactiveReasonModalTemplate } from 'themes/application/facility-order/components';
import { observer } from 'mobx-react';
import { setCurrentView } from 'core/utils';
import { EditFacilityOrderTemplateInactiveReasonModalStore } from 'application/facility-order/stores';

@setCurrentView((rootStore, componentProps) => new EditFacilityOrderTemplateInactiveReasonModalStore(rootStore, componentProps), 'editFacilityOrderTemplateInactiveReasonModalStore')
@observer
class EditFacilityOrderTemplateInactiveReasonModal extends React.Component {
    render() {
        return <EditFacilityOrderTemplateInactiveReasonModalTemplate {...this.props} />
    }
}

export default EditFacilityOrderTemplateInactiveReasonModal;
